import { FC, useEffect, useState } from "react";
import { useInitialStepStore } from "../../hooks/useInitialStepStore";
import { usePlanStore } from "../../hooks/usePlanStore";
import { Plan } from "../../types/slices/planType";
import { CustomSnackbar } from "../../components/common/CustomSnackbar/CustomSnackbar";
import { Modal } from "../../components/common/Modal/Modal";
import { ModalHeader } from "../../components/common/Modal/ModalHeader";
import { ModalBody } from "../../components/common/Modal/ModalBody";
import { Formik } from "formik";
import { Autocomplete, Checkbox, Divider, FormLabel, Grid, TextField } from "@mui/material";
import { ModalFooter } from "../../components/common/Modal/ModalFooter";
import { ApiStatus } from "../../types/api/status";

import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank'
import CheckBoxIcon from '@mui/icons-material/CheckBox'


type ValuesForm = {
    description: string
}

const Planes = [
    { id: 1, name: 'basic'},
    { id: 2, name: 'standar'},
    { id: 3, name: 'pro'}
]

export const InitialStepModal: FC<any> = (props) => {

    const { open, closeModal, onList, action } = props

    // const { status: statusPlan, plans, getPlans } = usePlanStore()
    const { status, initialStepSelected, createInitialStep, editInitialSTep } = useInitialStepStore()

    const [plansSelected, setPlansSelected] = useState<any>([])
    const [isEdit, setIsEdit] = useState<boolean>(false)
    const data: ValuesForm = {
        description: initialStepSelected ? initialStepSelected.description : ''
    }

    useEffect(() => {
        if (action !== 'create' && initialStepSelected.plans) {
            const planes = Planes.filter(plan => initialStepSelected.plans.includes(plan.name))
            setPlansSelected(planes || null)
        }
    }, [])

    const validateForm = (values) => {
        let errors: any = {};
        if (!values.description) errors.description = "el campo es requerido"
        return errors;
    }

    const onSubmit = async (values) => {
        if (plansSelected.length === 0) return CustomSnackbar('warning', 'Seleccione un plan')

        let payload: any = {
            description: values.description,
            plans: plansSelected.map(plan => plan.name)
        }

        const response = await (action === 'create' ? createInitialStep(payload) : editInitialSTep(initialStepSelected.id, payload))
        if (response === true) {
            onList()
            closeModal()
        }
    }

    return (
        <Modal open={open} handleClose={closeModal} disableEscapeKeyDown disableBackdropClick handle size="md" paperprops={{ style: { position: 'absolute', right: -30, borderRadius: 20, animation: 'slide-in 0.3s ease-out', maxHeight: '100%', height: '100vh' } }}>
            <ModalHeader
                text={action === 'detail' ? 'Detalle del paso inicial ' : (isEdit ? 'Editar paso inicial' : 'Nuevo paso inicial')}
                className='positionElements'
                onCancel={closeModal}
            >
            </ModalHeader>
            <ModalBody>
                <Formik initialValues={data} enableReinitialize validate={(values) => validateForm(values)} onSubmit={onSubmit}>
                    {({ values, errors, touched, handleSubmit, handleChange, setFieldValue }) => {
                        return (
                            <form onSubmit={handleSubmit}>
                                <Grid container sx={{ padding: '20px' }}>
                                    <Grid item container xs={12} spacing={2}>
                                        <Grid item xs={12}>
                                            <FormLabel>Descripción:</FormLabel>
                                            <TextField
                                                id="description"
                                                type="text"
                                                name="description"
                                                fullWidth
                                                size="small"
                                                value={values.description}
                                                onChange={handleChange}
                                                error={errors.description && touched.description ? true : false}
                                                helperText={errors.description && touched.description ? errors.description : ''}
                                                InputProps={{
                                                    readOnly: action === 'detail',
                                                }}
                                            />
                                        </Grid>
                                        <Grid item xs={12}>
                                            <FormLabel>Planes:</FormLabel>
                                            <Autocomplete
                                                multiple
                                                disablePortal
                                                id="combo-box-plan"
                                                value={plansSelected || []}
                                                options={Planes || []}
                                                getOptionLabel={(option) => option?.name || ""}
                                                fullWidth
                                                isOptionEqualToValue={(option, value) => option?.id === value?.id}
                                                renderInput={
                                                    (params) => <TextField {...params} size="small" />
                                                }
                                                onChange={(e, newValue) => {
                                                    setPlansSelected(newValue);
                                                }}
                                                renderOption={(props, option, { selected }) => (
                                                    <li value={option.id} {...props} key={option.id}>
                                                        <Checkbox
                                                            icon={<CheckBoxOutlineBlankIcon fontSize="small" />}
                                                            checkedIcon={<CheckBoxIcon fontSize="small" />}
                                                            checked={selected}
                                                        />
                                                        {option.name}
                                                    </li>
                                                )}
                                                filterSelectedOptions
                                                readOnly={action === 'detail'}
                                            />
                                        </Grid>
                                    </Grid>
                                </Grid>
                                <Divider />
                                {
                                    action !== 'detail' &&
                                    <ModalFooter
                                        buttonType="submit"
                                        confirmText={'Guardar'}
                                        onConfirm={handleSubmit}
                                        cancelText={"Cancelar"}
                                        onCancel={closeModal}
                                        loadingConfirmText={status === ApiStatus.FETCHING}
                                    />
                                }
                            </form>
                        )
                    }}
                </Formik>
            </ModalBody>
        </Modal>
    )
}